import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  padding: 1rem 0;
  /* position: relative;
  z-index: 500; */

  .closeRow {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: 100%;

    button {
      .closeIcon {
        color: ${({ theme }) => theme.button_primary};
        font-size: 1.75rem;
      }
    }
  }

  .iconRow {
    font-size: 3rem;
    color: ${({ theme }) => theme.font_secondary};
  }

  .textRow {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;

    .text {
      font-weight: 700;
      font-size: 1.125rem;
      color: #f2f2f2;

      @media screen and (max-width: 768px) {
        text-align: center;
      }
    }
  }

  .actionArea {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 1.75rem;

    button {
      border-radius: 0.5rem;
    }
    @media screen and (max-width: 768px) {
      flex-direction: column-reverse;
      gap: 1rem;
    }
  }
`;
